import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAddressFamilyName } from '../../../services/cards/components/CardElementAddress/helpers';

const propTypes = {
  address: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    post_code: PropTypes.string,
    country: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  familyName: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

const UserAddressDisplay = ({
  address = 'Address',
  familyName = false,
  title,
  className,
  children,
}) => {
  const classes = classNames({
    'user-address-info': true,
    'text-center': !address,
    [className]: !!className,
  });

  return address?.id || address?.address_line_1 ? (
    <div className={classes}>
      {title && <h4 className="user-address-info-title">{title}</h4>}

      <p className="user-address-info-item text-bold">
        {familyName ? getAddressFamilyName(address.name) : address.name}
      </p>
      <p className="user-address-info-item">
        {address.address_line_1}
        {address.address_line_2 && (
          <Fragment>
            <br /> <span>{address.address_line_2}</span>
          </Fragment>
        )}
      </p>
      <p className="user-address-info-item">
        {[
          address.city,
          address.state,
          address.post_code,
          address?.country?.name,
        ]
          .filter(Boolean)
          .join(', ')}
      </p>
      {children}
    </div>
  ) : (
    <div className={classes}>No address provided.</div>
  );
};

UserAddressDisplay.propTypes = propTypes;

export default UserAddressDisplay;
